import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { MajorDevCourse } from '../builders/major_dev_course_builder';

angular
  .module('major-explorer-data')
  .service(
    'loadDevelopmentalCoursesCommand',
    (
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngMajorDevCourseDatastore: IDatasource<MajorDevCourse>,
      log: any
    ) => {
      return defineCommand('loadDevelopmentalCoursesCommand', (deferred: ng.IDeferred<any>, programId: string) => {
        $http
          .get(`reg/program/${programId}/devreq`)
          .then(({ data }: { data: any }) => {
            ngMajorDevCourseDatastore.write(_4.toArray(data.course));
            ORM.run();
            deferred.resolve(data);
          })
          .catch((error) => {
            log.issue('failed to load developmental courses for this program');
            deferred.reject(error);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_developmental_courses_command.ts